module.exports = "pegasus_template/assets/theme4/small/3.jpg";